
import { Vue, Component, Prop } from "vue-property-decorator";
@Component({})
export default class HeaderOffers extends Vue {
  @Prop(Object) offer!: any;
  @Prop(String) offerType!: string;
  @Prop(Boolean) withTag!: boolean;
  @Prop(Boolean) withFav!: boolean;
  @Prop(Boolean) withNetwork!: boolean;
  @Prop(Boolean) withNetwork2!: boolean;
  @Prop(Boolean) withVacancies!: boolean;
  @Prop(Function) toggleOffer!: boolean;
  @Prop(Number) favorite!: Number;
  @Prop(Number) postulate!: Number;
  link_social = "";

  mounted() {
    const _this: any = this;
    _this.link_social = window.location.origin;
  }
}
